import { dedupePromise as i } from "./concurrentDedupe.js";
const u = /* @__PURE__ */ new Map();
function s(n) {
  return typeof n == "string" ? n : n instanceof URL ? n.href : n.toString();
}
function p(n) {
  return (n.split("?")[0].replace(/\/+$/, "") || "/").endsWith("/query");
}
function c(n) {
  const t = n?.body;
  return t == null ? "" : typeof t == "string" ? t : t instanceof URLSearchParams ? t.toString() : null;
}
function a(n, t) {
  const e = (t?.method ?? "GET").toUpperCase(), r = s(n);
  if (e === "GET")
    return `GET:${r}`;
  if (e === "POST" && p(r)) {
    const o = c(t);
    return o === null ? null : `POST:${r}:${o}`;
  }
  return null;
}
async function h(n, t) {
  return (await i(n, u, t)).clone();
}
export {
  h as fetchWithInFlightDedupe,
  a as getInFlightDedupeKey
};
